<template>
  <svg :width="width" :height="height" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_4117_49830)">
      <path d="M13.3337 11.6673H14.5837V14.0173L16.617 15.1923L15.992 16.2757L13.3337 14.7423V11.6673ZM20.0003 14.1673C20.0003 15.7144 19.3857 17.1981 18.2918 18.2921C17.1978 19.3861 15.7141 20.0007 14.167 20.0007C11.842 20.0007 9.83366 18.634 8.89199 16.6673H3.33366C2.40866 16.6673 1.66699 15.9173 1.66699 15.0007V5.00065C1.66699 4.07565 2.40866 3.33398 3.33366 3.33398H16.667C17.109 3.33398 17.5329 3.50958 17.8455 3.82214C18.1581 4.1347 18.3337 4.55862 18.3337 5.00065V10.084C19.367 11.134 20.0003 12.5757 20.0003 14.1673ZM14.167 10.0007C13.0619 10.0007 12.0021 10.4396 11.2207 11.221C10.4393 12.0024 10.0003 13.0622 10.0003 14.1673C10.0003 15.2724 10.4393 16.3322 11.2207 17.1136C12.0021 17.895 13.0619 18.334 14.167 18.334C15.2721 18.334 16.3319 17.895 17.1133 17.1136C17.8947 16.3322 18.3337 15.2724 18.3337 14.1673C18.3337 13.0622 17.8947 12.0024 17.1133 11.221C16.3319 10.4396 15.2721 10.0007 14.167 10.0007ZM16.667 8.33398V5.83398H3.33366V8.33398H16.667Z" :fill="iconColor"/>
    </g>
    <defs>
      <clipPath id="clip0_4117_49830">
        <rect :width="width" :height="height" fill="white"/>
      </clipPath>
    </defs>  </svg>
</template>

<script>
export default {
  props: {
    iconName: {
      type: String,
      default: "iconCreditCardClock",
    },
    width: {
      type: [Number, String],
      default: 20,
    },
    height: {
      type: [Number, String],
      default: 20,
    },
    iconColor: {
      type: String,
      default: "currentColor",
    },
  },
};
</script>
